<template lang="pug">
div(
  class="bg-anyvan-yellow rounded-4xl flex flex-col md:grid md:grid-cols-2 lg:flex lg:flex-col py-ds-lg px-[40px] justify-center md:justify-around lg:justify-center items-centers gap-ds-lg overflow-hidden"
)
  div(class="flex flex-col items-center md:items-end lg:items-center")
    span.whitespace-nowrap.text-black50.text-rebrandMd.text-center.leading-6xl {{ $t("summary.savings_line_1") }}
    h6(class="text-rebrandMd lg:text-rebrandXm text-black70") {{ locationData.displayName }}
    span.text-black50.text-rebrandMd.text-center.leading-6xl {{ $t("summary.savings_line_2") }}
  .counter-container.relative
    ClientOnly
      AnimatedFlipCounter(:value="counterValue" v-observe-visibility="onVisible")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_LOCATION_INFO } from "~/store/location"
import Confetti from "canvas-confetti"
import { getScreenWidth } from "~/scripts/useful-functions"

export default defineComponent({
  name: "AvSavings",
  data() {
    return {
      counterValue: 0 as number,
      intervalId: null as number | null,
      counterComplete: false,
      countingHasStarted: false
    }
  },
  computed: {
    ...mapGetters("location", {
      locationData: GET_LOCATION_INFO
    }),
    screenWidth(): number {
      return getScreenWidth() || 400
    }
  },
  methods: {
    onVisible() {
      if (!this.counterComplete) {
        this.startCounting()
      }
    },
    startCounting() {
      const targetValue = this.locationData.savings as number
      const duration = 1000 // 1 second
      const steps = 60 // 60 steps per second
      const increment = targetValue / ((duration / 1000) * steps)

      if (!this.countingHasStarted) {
        this.intervalId = window.setInterval(() => {
          if (this.counterValue < targetValue) {
            this.countingHasStarted = true
            this.counterValue = Math.min(this.counterValue + increment, targetValue)
          } else {
            this.stopCounting()
          }
        }, 1000 / steps)
      }
    },
    stopCounting() {
      if (this.intervalId !== null) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
      const origin = this.screenWidth > 991 ? { y: 0.8, x: 0.7 } : { y: 0.5, x: 0.5 }
      setTimeout(() => {
        Confetti({
          particleCount: 100,
          spread: 70,
          origin
        })
      }, 200)
      this.counterComplete = true
    }
  },
  beforeUnmount() {
    this.stopCounting()
  }
})
</script>

<style module lang="css">
:global {
  .counter-container {
    @apply text-center md:self-end lg:self-center;

    button {
      margin: 0 10px;
      padding: 5px 10px;
    }
  }
}
</style>
